import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Como recebo o e-book após a compra?",
    a: "Imediatamente após a confirmação do pagamento, você recebe um e-mail com o link de download do e-book em PDF e ePub. O acesso é vitalício: baixe quantas vezes quiser, para sempre.",
  },
  {
    q: "Posso ler no celular, tablet ou Kindle?",
    a: "Sim. O formato ePub é compatível com Kindle e apps de leitura (Apple Books, Google Play Livros), e o PDF abre em qualquer celular, tablet ou computador.",
  },
  {
    q: "Preciso conhecer filosofia para aproveitar o livro?",
    a: "Não. ESTÓICO foi escrito exatamente para quem nunca leu filosofia. Cada conceito antigo é explicado com exemplos do dia a dia e exercícios práticos ao fim de cada capítulo.",
  },
  {
    q: "E se eu não gostar do conteúdo?",
    a: "Você tem 7 dias de garantia incondicional. Basta enviar um e-mail e devolvemos 100% do valor, sem perguntas e sem burocracia.",
  },
  {
    q: "O pagamento é seguro?",
    a: "Sim. O checkout é processado por uma plataforma de pagamentos líder de mercado, com criptografia e proteção total dos seus dados. Aceita cartão, Pix e boleto.",
  },
];

export const Faq = () => (
  <section data-testid="faq-section" className="py-20 md:py-28">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Dúvidas frequentes</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
          Perguntas & <span className="text-gold-gradient italic">respostas</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="rounded-xl border border-[#d4af37]/15 bg-[#14141a] px-6 transition-colors duration-300 data-[state=open]:border-[#d4af37]/40"
            >
              <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="text-left font-sans text-sm sm:text-base font-bold text-[#f4f1ea] hover:text-[#f5d77f] hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-zinc-400 leading-relaxed pb-6">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
